import { styled } from '@mui/material/styles';
import { Modal } from 'core/common/ui/ui-kit';

export const ModalStyled = styled(Modal)`
  & .MuiPaper-root {
    gap: 24px;
    background: ${({ theme }) => theme.palette.payment.background};
  }

  * {
    color: ${({ theme }) => theme.palette.payment.primaryText};
  }
`;
